import { render, staticRenderFns } from "./ElementsStory.vue?vue&type=template&id=03712694&"
import script from "./ElementsStory.vue?vue&type=script&lang=ts&"
export * from "./ElementsStory.vue?vue&type=script&lang=ts&"
import style0 from "./ElementsStory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports